// extracted by mini-css-extract-plugin
module.exports = {"root":"c8DVItt","body":"kUE-Uy","carouselSlider":"wm4gVf","carousel":"vZ0DEx","product":"c9fujTI","header":"O1_t_O"};